import React, { useEffect, useState } from "react";
import { FieldValues, useFormContext, UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { useAppDispatch, useAppSelector } from "../../app/hook";
import { handleSetAiSpeedType, wizardState } from "./botSlice";
import { ConnectForm } from "./BotWizard";
import { AIKittyType } from "./types";

const ReactionSpeed = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const wizard = useAppSelector(wizardState);

  const { setValue, getValues } = useFormContext();

  const [data, setData] = useState([
    {
      key: "SMART",
      select: false
    },
    {
      key: "SMART_FAST",
      select: false
    },
    {
      key: "FAST_SMART",
      select: false
    },
    {
      key: "FAST",
      select: false
    }
  ]);

  const SelectBtn = ({
    title,
    center,
    left,
    right
  }: {
    title: string;
    left?: boolean;
    right?: boolean;
    center?: boolean;
  }) => {
    return (
      <div className="tw-relative ">
        <div className="tw-flex tw-items-center tw-justify-center tw-shadow-2xl  tw-bg-white tw-rounded-full tw-h-5 tw-w-5 shrink-0 tw-relative md:tw-right-0 tw-right-[5px]">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="6"
            height="6"
            viewBox="0 0 6 6"
            fill="none"
          >
            <circle cx="3" cy="3" r="3" fill="#4167DA" />
          </svg>
        </div>

        <div
          className={`tw-absolute 
              tw-top-0 md:tw-top-12 lg:tw-top-12
              tw-left-8 md:tw-left-0 
              tw-border-0 
              tw-rounded-lg tw-bg-gradient-to-r tw-from-blue-500 tw-to-blue-600
              tw-shadow-lg tw-transform hover:tw-scale-105 
              tw-transition-all tw-duration-300
              ${center ? "md:tw-left-[-10px] md:tw-right-[-90px]" : ""} 
              ${right ? "tw-right-0" : ""} 
              tw-flex tw-flex-col tw-items-center tw-gap-2 
              tw-w-[150px] md:tw-w-[150px] 
              tw-p-4`}
        >
          <div className="tw-text-white tw-text-xl tw-font-bold">🌟</div>
          <div
            className={`
      ${right || left || center ? "md:tw-text-left" : "tw-text-center"} 
      tw-text-white tw-text-base tw-font-semibold 
      tw-font-['Sofia Sans'] tw-leading-snug`}
          >
            {title}
          </div>
        </div>
      </div>
    );
  };

  const SelectDefaultBtn = ({
    title,
    center,
    left,
    right,
    onClick
  }: {
    title: string;
    left?: boolean;
    right?: boolean;
    center?: boolean;
    onClick?: () => void;
  }) => {
    return (
      <div
        className="tw-relative tw-cursor-pointer tw-inline-block"
        onClick={onClick}
        onKeyDown={onClick}
        role="button"
        tabIndex={0}
        aria-label="select-speed"
      >
        <div
          className={`tw-flex tw-bg-gray-300 tw-items-center tw-justify-center tw-h-2 tw-w-2 ${
            left && "tw-rounded-s-2xl"
          } ${right && "tw-rounded-e-2xl"}`}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="6"
            height="6"
            viewBox="0 0 6 6"
            fill="none"
          >
            <circle cx="3" cy="3" r="3" fill="#ffffff" />
          </svg>
        </div>

        <div
          className={`tw-absolute md:tw-top-6 tw-top-0 md:tw-left-0 tw-left-8 ${
            center ? "md:tw-left-[-10px]" : ""
          } ${
            right ? "md:tw-right-[0px]" : ""
          } tw-flex tw-flex-col tw-gap-2 md:tw-w-[200px] tw-w-[200px]`}
        >
          <div
            className={`${right ? "md:tw-text-left" : ""} ${
              left ? "md:tw-text-left" : ""
            } ${
              center ? "md:tw-text-left" : ""
            } tw-text-zinc-900 tw-text-sm tw-font-bold tw-font-['Sofia Sans'] tw-leading-tight`}
          >
            {title}
          </div>
        </div>
      </div>
    );
  };

  const IconTurtle = () => {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        xlinkHref="http://www.w3.org/1999/xlink"
      >
        <rect
          opacity="0.6"
          width="24"
          height="24"
          fill="url(#pattern0_10761_20549)"
        />
        <defs>
          <pattern
            id="pattern0_10761_20549"
            patternContentUnits="objectBoundingBox"
            width="1"
            height="1"
          >
            <use xlinkHref="#image0_10761_20549" transform="scale(0.0111111)" />
          </pattern>
          <image
            id="image0_10761_20549"
            width="90"
            height="90"
            xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAAE2ElEQVR4nO2cW4hWVRTHf6XZxTHMQi2xiyElgimiWVkPQYQPXR7KCknrIQWvoBRGGoEaQQ9qWWEPBYkEhfRQVFqGDWpJg2U3sbRSS9RSu2pjM7Njwxr4qO+c79zP+s63fvB/mJfv7L3YZ+11OwOGYRiGYRiGYRiGYRiGYRiGYRiGbtqAKcBSYD3QAewHjgNdwF/AIWA3sAV4FngImAD0KXvx2hkMLAC2Av8ALqGOAi8BdwD9yt6UJvwp3ACcTmHcIPlT/xhwES3MWGBTDsZ1dXQSWAH0p4U4H1gtvtYVrIPAPbQA44G9JRjY/Ufr5MKtJLOBTgVGdiIfsYymQpwBPKHAsK6OTgDXUxEjv6DAoC5EfwA30+Q8qcCQLmJU4sPMpvXJrol0CBgumaUPPa9thixzgrKLz0XUZ8AnNX9/BVyO4jh5nwKjuYz0bsR9++xzDrAZ+B44JXH7O8B9wNlZG3q1AuO4DOXfzDC8e5kP/Nbgd74FbsrKyGNLyvhcjvqhwdu7McZvdUvhLDVF1S5cgXowYK9DgM8T/uaitBegq5C6JHKqx0BgZ4rf7k4Tu29QYByXkX4GbgkxckcGz/gxSb1lcE71ZFeCPgYuDdjnAGB7hs96JK6hFygwkEsp39VZBpwVsMfzpG2W5TOPAOfEMfQ2BYZyKeRDr+tC9ueN8V5Oz741qpEHNLHb6JRTfG4DI7+d4xpWRjX0FAUGcwnk3cCoBntrk0wvz3V4nx+JxxUYzcXQN8DdUsIN44KML74g+XQ9EusVGM9F0GGJi4Muu1pGAl8XWKKNRG21S6OOyiBOWwxXeKLA9flnReKAAmO6OvoOmCthWRT8pfe0ZG1FrtO/OZE4rsCorkY7pSzZN+oGgHHAFyWt98Woi0wzvpWVfpXeZNx2lL/wnil5D0Gp/v8oq5PSIyHa9BjuoRd/2meK/y7zgPjQsWGxe0kJ/rlbstCHgRHE50xgmmSCWa2pU6ZZrwGuijEg5ItKwxoteFGBxv1bMjN/AoeSDD9V+oD0ALNc25di4FouBF6XNy6scHVZlIV/mqNhe4BdwCrgduliJMVv+lHpcGe9zrek/BDEJOBVObmnZQ1vSLLk3yyKNnSn1HfXAHdlNGJ7o8zXncrpMKyLGdUkZmHCBR6TtHYtMEuGHrMaFr9aEpO8M7rn45zItPSRV3J/zVjVL3LJ7ADelHDLb3wGcENOw+AjZdB8V87G7dVTtBCjgcUpe3ZJ5ItnlWaIXCBrS0z3fShbOS4G7pTYtKgKWlgENI8K4EO3ydJzfCWHODeLBKlhUqEJ36KfCNwPLAdekwJ8WFDvlEjNie4vt/9k8aXz5Quol4F26fS6JlY7Siii3eNKdh+XoIBBObbinRKpcR99pdDUaHS1WdWOMoZKRphXjcG1uvuol2SskM6Hq4jmoZii02QXoh6Z395TFffRy5UKjOuA34HnaqaSJibsEap1H4tLNO4RyTRvC/hIZ1mV3MeOhAN/U6UnuEa6GB3yuh+U0QZ/sv4EfpJayEfSOloq/wzlighr65ewefEhConbHd9a8AeUY6QfGfdLAHW8H/PLp2ElrPHemCPHH6CQ4XJTd4VEAQekHOqbqGUxXr6/CZvx6JZSg9qvaA3DMAzDMAzDMAzDMAzDMAzDMGhZ/gUnrmQP0NxNwAAAAABJRU5ErkJggg=="
          />
        </defs>
      </svg>
    );
  };

  const IconRabbit = () => {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        xlinkHref="http://www.w3.org/1999/xlink"
      >
        <rect
          opacity="0.6"
          width="24"
          height="24"
          fill="url(#pattern0_10761_20548)"
        />
        <defs>
          <pattern
            id="pattern0_10761_20548"
            patternContentUnits="objectBoundingBox"
            width="1"
            height="1"
          >
            <use xlinkHref="#image0_10761_20548" transform="scale(0.0111111)" />
          </pattern>
          <image
            id="image0_10761_20548"
            width="90"
            height="90"
            xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAAFGUlEQVR4nO2cWYhcRRSGv4k6zrhEA+ZhZIIxElwQ10gUH1yCCyoiERHX4IMiRI1LVHwQNQQ3QgR3xQ0f3KIkSBTBF1FcghHNkETUMSqMS1DcZtQxjnPlyLnQNN13qure27fu9PngvFV3Vf1dXXXq1KkCwzAMwzAMwzAMwzAMo5PsBqwAhoEJ4DfgO2AL8CqwGrgcOATosZ8mXOT3gcTRfgJeBi4A9gyssytZ4SFys/0FvAgcX3Un6sBwDqEb7UPgXJta2vN3QUKn9i5wbEZ9XctwwUKLTQKPALsT0UL0EPCrYwd+AR4E+gtswx0lCJ3aZ8AxRMCjgR2QzxVFP/BeiWKPA+dRITOAPwMb/4d+vkixbwe+UD869Sh+bmG/B7T3X+A6KiImoUPZB1gAXAI8rZucrHb/oz+WrAtvAKuAszoxl4dOHbLQxEgvcGnAAiv/kseBA8pqmPxlH9BFzqVBMhruL3gxLIOZwJqAAbQDuAfYtZRWTUNmAK/lWEA/AGZX3Yk6cGUB3somYO+qOxIz/cBIAUKLPUfN6NXAz83Aeh0tI+r1pJ7AN8AG4AXgTuAcYCCgrlsKEjm1s6kBA8BK4MccHf0aeB5YCsyfor4FOVzWdrYl5hj4TPVOig4YiX0JPKy7vf2APmAesFwPDJISbFGMMY0jgW0ldbgqE+2iimksAsYiEKZoG3IVoBNb7YUlzI+x2GgsQs92iDPU2STQFUVMY00EYpRpMuAqj2mcEIEQSckmelTOWxEIkZRs4lJWyuERiJB0wGQwVcrqCERIOmBPVC30tpp5DlcFemAXVinyvAjESzxMBEZPUV5qOJt0mZ9lm18ZF0cgXuJh4nE1B7yuAJ4FPga264n5hHoZI5puNrcsAeXXW6YhyzG1Id3vn9wQybq3IsGeUXFcR2Rq3xMRgxorzmrwp8BiYG2F2+FB4GBP11LCnVHQ5yByc65EVdPAY9pm+Xdd6zi63yYSllUoXBKQHiCh35QzHKKGrxAJGyIQMPGw05rav1iTG9uVF58/CkYjEC/xMDlXbOaujPLiQ0dB3YRe26IPEgT7tk3504mEuk0dmz3TgPclEq6JQLykAL/4uBZlfyAiJN/sE4+OrtdE79iOl2a1KCtb7qgYdBB7a0OQ5Wg9fUgqMEm8acXOLcpeRoTIyL5a7/6Naq7EJj2hOaVFMslJgcnhSUmnHs0jejIw4ylKDtJ4SCeF/qhNW+Y6lqstuwA35Uz/8jHJVnI59bmRacoemp71eclCn5qRxJOWGdOpZNozoIIs19BmUV6KXJ3YySE3ut2o7woWerqRreyijO+/r+FWV2l3Uuo00icCRX5ziu9+XcvJdToD+CrQpcsapT26GG+u+pwvFvbSG1A+Iu9wyFM+UN/z6PopI+UGT5En9NLmVMjCe5hDua5g0HMnOa7vcBge9GgwylVkOfK3tzcCWOohskTc7FJlAPt7pmMN6VW2OSGVdTNP5giHSqK7PVDlyPacu8F0syJ3CY0M2h2a+prEl5+ye9rtubsgoRs9kjMz6utaelXsokZ2OrpXRvIaTpT06/H/ocCJ+t7ROt0+h2bkm9geSIz5fGBjgNiSRmwEsMRzqz6pD1EZAcz3fIhKQq/2HlIgczxj1/LcsRHIURrFcxFadpFGDq73eLHGyOmRuGS8ysg3cnKEBpmyhJZ8EqMAVk0h9G1FVGLw/67ynYzX0GN/zrNW9AG36jQxrs8hy0g2kQ3DMAzDYPrzHx6lz30QXgk4AAAAAElFTkSuQmCC"
          />
        </defs>
      </svg>
    );
  };

  const onSelect = (key: string) => {
    setData((prev) => {
      const temp = [...prev];
      temp.forEach((item) => {
        item.select = false;
      });
      const tempData = temp.map((item) =>
        item.key === key ? { ...item, select: true } : item
      );

      return tempData;
    });

    setValue("model", key);
  };

  useEffect(() => {
    onSelect((wizard.bot_config as AIKittyType).modelTitle);
  }, [(wizard.bot_config as AIKittyType).modelTitle]);

  return (
    <ConnectForm>
      {({
        setValue,
        formState: { errors }
      }: UseFormReturn<FieldValues, any>) => (
        <div className="tw-grid tw-grid-cols-12 md:tw-gap-0 tw-gap-7">
          <div className="md:tw-col-span-9 tw-col-span-12 tw-flex-col tw-justify-start tw-tw-items-start tw-inline-flex md:tw-w-[80%] tw-w-full">
            <div className="tw-self-stretch tw-flex-col tw-justify-start tw-items-start tw-gap-8 tw-flex tw-mb-8 tw-w-full">
              <div className="tw-self-stretch tw-flex-col tw-justify-start tw-items-start tw-gap-2 tw-flex">
                <div className="tw-self-stretch tw-text-gray-900 tw-text-2xl tw-font-semibold tw-font-['Lexend'] tw-leading-loose">
                  {t("Wizard/ReactionSpeed/key1")}
                </div>
                <div className="tw-self-stretch tw-text-gray-900 text-sm font-normal tw-font-['Lexend'] tw-leading-tight">
                  {t("Wizard/ReactionSpeed/key2")}
                </div>
              </div>
              {errors.model && (
                <div className="tw-self-stretch tw-text-red-600 tw-text-xs tw-font-['Lexend'] tw-leading-none tw-block">
                  {errors?.model?.message as string}
                </div>
              )}
            </div>

            <div className="tw-flex tw-w-full md:tw-mt-14 tw-mt-4 tw-gap-2 md:tw-flex-row tw-flex-col">
              <IconTurtle />
              <ol className="tw-m-0 tw-p-0 tw-flex md:tw-items-center md:tw-justify-between tw-w-full md:tw-flex-row tw-flex-col">
                <li className="tw-flex md:tw-w-full md:tw-flex-row tw-flex-col md:tw-justify-center md:tw-items-center text-primary  after:tw-content-[''] md:after:tw-w-full after:tw-w-2 after:tw-h-[100px]  after:tw-border-b after:tw-border-blue-500 after:tw-bg-gray-300 md:after:tw-h-2 after:tw-border-4 after:tw-inline-block ">
                  {data.find((dr) => dr.key == "SMART")?.select && (
                    <SelectBtn
                      title={t("AssistantSpeedPage/l-1")}
                      left={true}
                    />
                  )}
                  {!data.find((dr) => dr.key == "SMART")?.select && (
                    <SelectDefaultBtn
                      onClick={() => {
                        onSelect("SMART");
                        setValue("model", "SMART");
                        dispatch(handleSetAiSpeedType("SMART"));
                      }}
                      title={t("AssistantSpeedPage/l-1")}
                      left={true}
                    />
                  )}
                </li>
                <li className="tw-flex md:tw-w-full md:tw-flex-row tw-flex-col md:tw-justify-center md:tw-items-center text-primary  after:tw-content-[''] md:after:tw-w-full after:tw-w-2 after:tw-h-[100px]  after:tw-border-b after:tw-border-blue-500 after:tw-bg-gray-300 md:after:tw-h-2 after:tw-border-4 after:tw-inline-block ">
                  {data.find((dr) => dr.key == "SMART_FAST")?.select && (
                    <SelectBtn
                      title={t("AssistantSpeedPage/l-2")}
                      center={true}
                    />
                  )}
                  {!data.find((dr) => dr.key == "SMART_FAST")?.select && (
                    <SelectDefaultBtn
                      onClick={() => {
                        onSelect("SMART_FAST");
                        setValue("model", "SMART_FAST");
                        dispatch(handleSetAiSpeedType("SMART_FAST"));
                      }}
                      title={t("AssistantSpeedPage/l-2")}
                      center={true}
                    />
                  )}
                </li>
                <li className="tw-flex md:tw-w-full md:tw-flex-row tw-flex-col md:tw-justify-center md:tw-items-center text-primary  after:tw-content-[''] md:after:tw-w-full after:tw-w-2 after:tw-h-[100px]  after:tw-border-b after:tw-border-blue-500 after:tw-bg-gray-300 md:after:tw-h-2 after:tw-border-4 after:tw-inline-block ">
                  {data.find((dr) => dr.key == "FAST_SMART")?.select && (
                    <SelectBtn
                      title={t("AssistantSpeedPage/l-3")}
                      center={true}
                    />
                  )}
                  {!data.find((dr) => dr.key == "FAST_SMART")?.select && (
                    <SelectDefaultBtn
                      onClick={() => {
                        onSelect("FAST_SMART");
                        setValue("model", "FAST_SMART");
                        dispatch(handleSetAiSpeedType("FAST_SMART"));
                      }}
                      title={t("AssistantSpeedPage/l-3")}
                      center={true}
                    />
                  )}
                </li>
                <li className="tw-flex">
                  {data.find((dr) => dr.key == "FAST")?.select && (
                    <SelectBtn
                      title={t("AssistantSpeedPage/l-4")}
                      right={true}
                    />
                  )}
                  {!data.find((dr) => dr.key == "FAST")?.select && (
                    <SelectDefaultBtn
                      onClick={() => {
                        onSelect("FAST");
                        setValue("model", "FAST");
                        dispatch(handleSetAiSpeedType("FAST"));
                      }}
                      title={t("AssistantSpeedPage/l-4")}
                      right={true}
                    />
                  )}
                </li>
              </ol>
              <IconRabbit />
            </div>
          </div>
        </div>
      )}
    </ConnectForm>
  );
};

export default ReactionSpeed;
